import ReactDOM from 'react-dom/client';
import './bootstrap-3.3.7/dist/css/bootstrap.min.css';
import "./App.css";
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App/>);